import HotelOnly from './HotelOnly';

export default HotelOnly;
